import React from 'react';
import { enumColumnTypes, columnTypes } from '../types';
var addClassBasedOnType = function (type) {
    var clazz = type + 'Cell';
    switch (type) {
        case columnTypes.ENUM_TYPE:
        case enumColumnTypes.ICON_TYPE:
            return clazz + ' graphicCell';
        default:
            return clazz;
    }
};
var Cell = function (_a) {
    var column = _a.column, _b = _a.item, item = _b === void 0 ? null : _b, cellFactory = _a.cellFactory;
    return (React.createElement("td", { style: { width: column.width } },
        React.createElement("div", { className: 'cell' },
            React.createElement("div", { className: addClassBasedOnType(column.type) + " ellipsis" }, cellFactory(column, item)))));
};
export default Cell;
//# sourceMappingURL=Cell.js.map